/* eslint-disable */
// Retail Margin Calculator engine — the former public/calculators/retail-margin.html
// script, unchanged except that DOM lookups are scoped to `root`, the parent
// postMessage calls go through `hooks.post`, and the cpg* bridge is returned
// instead of living on window. Inline handlers in the markup / templates
// (showTab, tip, calculate, distribState) are exposed on window while mounted.
export function mountRetailMargin(root, hooks) {
  const st = {};
  const bridge = {};
  const docListeners = [];
  const onDoc = (t, f) => { document.addEventListener(t, f); docListeners.push([t, f]); };

const $=id=>root.querySelector('#'+CSS.escape(id));
const fmt=n=>n==null?'—':'$'+Math.round(n).toLocaleString('en-US');
const fmtD=(n,d=2)=>'$'+parseFloat(n).toFixed(d);
const fmtP=n=>(n*100).toFixed(1)+'%';
const v=id=>parseFloat($(id).value)||0;

// TAB SYSTEM
const TABS=['welcome','cogs','pricing','channels','trade','results'];
function showTab(id){
  root.querySelectorAll('.tab-panel').forEach(p=>p.classList.remove('active'));
  root.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('active'));
  $('tab-'+id).classList.add('active');
  root.querySelectorAll('.tab-btn').forEach(b=>{
    if(b.getAttribute('onclick')===`showTab('${id}')`) b.classList.add('active');
  });
  const idx=TABS.indexOf(id);
  $('progressFill').style.width=Math.max(10,(idx/(TABS.length-1))*100).toFixed(0)+'%';
  hooks.scrollTop();
}

// TOOLTIP
let tipT;
function tip(btn,title,text){
  const p=$('tipPopup');
  $('tipTitle').textContent=title; $('tipBody').textContent=text;
  const r=btn.getBoundingClientRect();
  let top=r.bottom+7, left=r.left-8;
  if(left+305>window.innerWidth) left=window.innerWidth-315;
  if(top+180>window.innerHeight) top=r.top-180;
  p.style.top=top+'px'; p.style.left=left+'px'; const pr=p.getBoundingClientRect(); p.style.top=(2*top-pr.top)+'px'; p.style.left=(2*left-pr.left)+'px';
  p.classList.add('visible');
  clearTimeout(tipT);
  tipT=setTimeout(()=>p.classList.remove('visible'),6000);
}
onDoc('click',e=>{if(!e.target.classList.contains('ib'))$('tipPopup').classList.remove('visible');});

// CHANNEL CONFIG
const CHANNELS=[
  {id:'conv', name:'Convenience', icon:'⛽', color:'var(--conv)', distribId:'distrib_conv', marginId:'ch_conv', direct:true},
  {id:'groc', name:'Grocery',     icon:'🛒', color:'var(--groc)', distribId:'distrib_groc', marginId:'ch_groc', direct:false},
  {id:'drug', name:'Drug',        icon:'💊', color:'var(--drug)', distribId:'distrib_drug', marginId:'ch_drug', direct:false},
  {id:'mass', name:'Mass',        icon:'🏬', color:'var(--mass)', distribId:'distrib_mass', marginId:'ch_mass', direct:true},
  {id:'alt',  name:'Natural/Alt', icon:'🌿', color:'var(--alt)',  distribId:'distrib_alt',  marginId:'ch_alt',  direct:false},
];
// distributor state per channel
const distribState={conv:false, groc:true, drug:true, mass:false, alt:true};

// Build distributor toggles
function buildDistribToggles(){
  const wrap=$('distrib_toggles');
  wrap.innerHTML=CHANNELS.map(ch=>`
    <label style="display:flex;align-items:center;gap:0.45rem;font-size:0.75rem;cursor:pointer;">
      <button id="${ch.distribId}" class="ch-toggle ${distribState[ch.id]?'on':''}" style="font-size:0.6rem;padding:0.15rem 0.45rem;"
        onclick="distribState['${ch.id}']=!distribState['${ch.id}'];this.classList.toggle('on');calculate();">
        ${distribState[ch.id]?'Via Distributor':'Direct'}
      </button>
      <span style="color:${ch.color}">${ch.icon}</span> ${ch.name}
    </label>`).join('');
}
buildDistribToggles();

// CALCULATE
function calculate(){
  const cogs = v('ci_ingred')+v('ci_pack')+v('ci_labour')+v('ci_freight')+v('ci_qa')+v('ci_ovhd');
  const upc  = Math.max(1, v('ci_upc'));
  const outF = v('ci_outfreight'); // per case

  $('cogs_total').innerHTML=`<span><strong>Total COGS / Unit</strong></span><span id="cogs_total_val"><strong>${fmtD(cogs)}</strong></span>`;

  const msrp    = v('pr_msrp');
  const dtcP    = v('pr_dtc');
  const whslP   = v('pr_whsl');
  const distP   = v('pr_dist');
  const distMgn = v('ch_distrib_margin')/100;
  const cogsCase = cogs * upc;

  // Pricing suggestions
  if(msrp>0){
    const sugg=[];
    const avgRetMgn=0.40; // 40% assumed for suggestion
    const sugWhsl=(msrp*(1-avgRetMgn)*upc).toFixed(2);
    const sugDist=(msrp*(1-avgRetMgn)*upc/(1+0.22)).toFixed(2);
    $('pricing_suggestions').innerHTML=`
      <div class="sub-total ok" style="margin-bottom:0.55rem;">
        <span>Suggested Wholesale / Case <span style="font-size:0.65rem;color:var(--mist)">(40% retailer margin)</span></span>
        <span>${fmtD(sugWhsl)}</span>
      </div>
      <div class="sub-total ok">
        <span>Suggested Distributor / Case <span style="font-size:0.65rem;color:var(--mist)">(22% distrib margin)</span></span>
        <span>${fmtD(sugDist)}</span>
      </div>
      <p style="font-size:0.73rem;color:var(--mist);margin-top:0.6rem;line-height:1.55;">These are starting points based on average market margins. Adjust based on your actual buyer conversations.</p>`;
  } else {
    $('pricing_suggestions').innerHTML=`<p style="font-size:0.78rem;color:var(--mist)">Enter your MSRP on this page to see suggested wholesale and distributor prices.</p>`;
  }

  // Trade spend
  const slotting    = v('ts_slotting');
  const freefillCs  = v('ts_freefill');
  const demo        = v('ts_demo');
  const promoPct    = v('ts_promo_pct')/100;
  const promoWks    = v('ts_promo_weeks');
  const scanback    = v('ts_scanback');   // per case
  const mdfPct      = v('ts_mdf')/100;
  // effective promo cost as fraction of annual revenue (promoWks/52 × promoPct)
  const effPromo    = promoPct * (promoWks/52);

  // Per-channel calculations
  const channelData = CHANNELS.map(ch=>{
    const retMgn  = v(ch.marginId)/100;
    const viaDistrib = distribState[ch.id];
    // Wholesale price per case (what retailer pays you)
    const whslCase = whslP > 0 ? whslP : (msrp>0 ? msrp*(1-retMgn)*upc : 0);
    // Your effective receipt per case
    const yourReceipt = viaDistrib
      ? (distP > 0 ? distP : whslCase/(1+distMgn))
      : whslCase;
    const distribCut = viaDistrib ? (whslCase - yourReceipt) : 0;
    const retailerCut = msrp>0 ? msrp*retMgn*upc : (whslCase / (1-retMgn) * retMgn);
    // Trade spend per case
    const tradePerCase = yourReceipt * (effPromo + mdfPct) + scanback + outF;
    const grossProfitCase = yourReceipt - cogsCase - tradePerCase;
    const gm = yourReceipt > 0 ? grossProfitCase / yourReceipt : 0;
    return {
      ...ch, retMgn, viaDistrib, whslCase, yourReceipt, distribCut, retailerCut,
      tradePerCase, grossProfitCase, gm, cogsCase
    };
  });

  // DTC calc
  const dtcReceipt    = dtcP > 0 ? dtcP : (msrp>0 ? msrp : 0);
  const dtcGP         = dtcReceipt - cogs;
  const dtcGM         = dtcReceipt > 0 ? dtcGP/dtcReceipt : 0;

  // Build channel cards
  $('channel_cards').innerHTML = `<div class="channel-grid">${channelData.map(ch=>`
    <div class="channel-card">
      <div class="channel-card-hdr">
        <div class="ch-name"><div class="ch-dot" style="background:${ch.color}"></div>${ch.icon} ${ch.name}</div>
        <span style="font-family:var(--font-mono);font-size:0.65rem;color:var(--mist);">${(ch.retMgn*100).toFixed(0)}% retailer margin</span>
      </div>
      <div class="channel-card-body">
        <div class="ch-row"><span class="ch-row-label">Wholesale / case</span><span class="ch-row-val">${fmtD(ch.whslCase)}</span></div>
        ${ch.viaDistrib?`<div class="ch-row negative"><span class="ch-row-label">Less distributor</span><span class="ch-row-val">(${fmtD(ch.distribCut)})</span></div>`:'<div class="ch-row"><span class="ch-row-label">Direct (no distributor)</span><span class="ch-row-val" style="color:var(--forest)">✓</span></div>'}
        <div class="ch-row"><span class="ch-row-label">You receive / case</span><span class="ch-row-val">${fmtD(ch.yourReceipt)}</span></div>
        <div class="ch-row negative"><span class="ch-row-label">Less COGS / case</span><span class="ch-row-val">(${fmtD(ch.cogsCase)})</span></div>
        <div class="ch-row negative"><span class="ch-row-label">Less trade spend / case</span><span class="ch-row-val">(${fmtD(ch.tradePerCase)})</span></div>
        <div class="ch-row highlight"><span class="ch-row-label">Gross profit / case</span><span class="ch-row-val" style="color:${ch.grossProfitCase>=0?'var(--forest)':'var(--rust)'};">${fmtD(ch.grossProfitCase)}</span></div>
        <div class="ch-row highlight"><span class="ch-row-label">Gross margin %</span><span class="ch-row-val" style="color:${ch.gm>=0.3?'var(--forest)':ch.gm>=0.15?'var(--status-caution)':'var(--rust)'};">${fmtP(ch.gm)}</span></div>
      </div>
    </div>`).join('')}</div>`;

  // Waterfall bars (channel tab)
  buildWaterfall('wf_bars', channelData, 220, true);
  // Results bars
  buildWaterfall('results_bars', channelData, 260, false);

  // Compare table
  const bestCh = channelData.reduce((b,c)=>c.gm>b.gm?c:b, channelData[0]);
  $('compare_tbody').innerHTML = [
    {name:'DTC / Online', icon:'🌐', color:'#c8a84b', viaDistrib:false,
     whslCase:dtcReceipt, retailerCut:0, distribCut:0, yourReceipt:dtcReceipt,
     cogsCase, tradePerCase:outF, grossProfitCase:dtcGP, gm:dtcGM},
    ...channelData
  ].map(ch=>{
    const isBest=ch.id?ch.id===bestCh.id:false;
    const cls = ch.gm>=0.4?'best':ch.gm<0.15?'worst':'';
    return `<tr class="${isBest?'highlight-row':''}">
      <td><div class="ch-badge"><div class="dot" style="background:${ch.color};width:8px;height:8px;border-radius:50%;"></div>${ch.icon} ${ch.name}</div></td>
      <td>${ch.viaDistrib?'Yes':'No'}</td>
      <td>${msrp>0?fmtD(msrp*upc):'—'}</td>
      <td class="${ch.retailerCut>0?'worst':''}">${ch.retailerCut>0?'('+fmtD(ch.retailerCut)+')':'—'}</td>
      <td class="${ch.distribCut>0?'worst':''}">${ch.distribCut>0?'('+fmtD(ch.distribCut)+')':'—'}</td>
      <td>${fmtD(ch.yourReceipt)}</td>
      <td class="worst">(${fmtD(ch.cogsCase)})</td>
      <td class="${ch.tradePerCase>0?'worst':''}">${ch.tradePerCase>0?'('+fmtD(ch.tradePerCase)+')':'—'}</td>
      <td class="${cls}">${fmtD(ch.grossProfitCase)}</td>
      <td class="${cls}">${fmtP(ch.gm)}</td>
    </tr>`;
  }).join('');

  // Results KPIs
  const flash=id=>{const e=$(id);e.classList.add('updating');setTimeout(()=>e.classList.remove('updating'),400);};
  ['r_cogs','r_dtc_gm','r_best_ch','r_trade_pct','r_net_margin'].forEach(flash);
  $('r_cogs').textContent=fmtD(cogs);
  $('r_dtc_gm').textContent=fmtP(dtcGM);
  if(bestCh){$('r_best_ch').textContent=bestCh.icon+' '+bestCh.name;$('r_best_gm').textContent=fmtP(bestCh.gm)+' gross margin';}
  const avgTrade=channelData.reduce((s,c)=>s+c.tradePerCase,0)/channelData.length;
  const avgReceipt=channelData.reduce((s,c)=>s+c.yourReceipt,0)/channelData.length;
  $('r_trade_pct').textContent=avgReceipt>0?fmtP(avgTrade/avgReceipt):'—';
  const avgGM=channelData.reduce((s,c)=>s+c.gm,0)/channelData.length;
  $('r_net_margin').textContent=fmtP(avgGM);

  // Trade summary
  if(whslP>0||distP>0){
    const promoAnn=promoPct*promoWks/52;
    const totTradePct=(effPromo+mdfPct+(scanback>0?scanback/((distP||whslP)):0))*100;
    $('trade_summary').innerHTML=`
      ${[
        {label:'Promo allowance (annualised)', val:`${(promoAnn*100).toFixed(1)}% of revenue`},
        {label:'MDF requirement', val:`${(mdfPct*100).toFixed(1)}% of revenue`},
        {label:'Scan-back per case', val:fmtD(scanback)},
        {label:'Outbound freight per case', val:fmtD(outF)},
        {label:'Slotting (one-time)', val:fmt(slotting)},
        {label:'Free fill COGS cost', val:fmt(freefillCs*cogsCase)},
        {label:'Demo budget (quarterly)', val:fmt(demo)},
      ].map(r=>`<div class="ch-row"><span class="ch-row-label">${r.label}</span><span class="ch-row-val">${r.val}</span></div>`).join('')}
      <div class="sub-total warn" style="margin-top:0.65rem;">
        <span>Est. total ongoing trade spend</span>
        <span>~${totTradePct.toFixed(1)}% of revenue</span>
      </div>`;
  }
}

function buildWaterfall(containerId, channelData, chartH, showDTC){
  const cogs   = v('ci_ingred')+v('ci_pack')+v('ci_labour')+v('ci_freight')+v('ci_qa')+v('ci_ovhd');
  const upc    = Math.max(1,v('ci_upc'));
  const msrp   = v('pr_msrp');
  const dtcP   = v('pr_dtc');
  const dtcReceipt = dtcP||msrp||0;
  const dtcGP  = dtcReceipt - cogs;
  const dtcGM  = dtcReceipt>0?dtcGP/dtcReceipt:0;
  const outF   = v('ci_outfreight');

  const allCh = showDTC ? [] : [];
  const allData = [
    ...(showDTC?[{name:'DTC',icon:'🌐',color:'#c8a84b',yourReceipt:dtcReceipt,
      cogsCase:cogs,tradePerCase:outF,distribCut:0,retailerCut:0,
      grossProfitCase:dtcGP-outF}]:[]),
    ...channelData
  ];

  const maxV = Math.max(...allData.map(c=>Math.max(c.yourReceipt+(c.distribCut||0)+(c.retailerCut||0),0.01)),0.01);

  $( containerId).innerHTML = allData.map(ch=>{
    const total = ch.yourReceipt + (ch.distribCut||0) + (ch.retailerCut||0);
    const scale = chartH/maxV;
    const segs=[
      {h:Math.max(0,(ch.cogsCase||0)*scale), cls:'seg-cogs'},
      {h:Math.max(0,(ch.tradePerCase||0)*scale), cls:'seg-trade'},
      {h:Math.max(0,(ch.distribCut||0)*scale), cls:'seg-distrib'},
      {h:Math.max(0,(ch.retailerCut||0)*scale), cls:'seg-retail'},
      {h:Math.max(0,(ch.grossProfitCase||0)*scale), cls:'seg-yours'},
    ].filter(s=>s.h>0.5);
    const totalH=segs.reduce((s,g)=>s+g.h,0);
    return `<div class="wf-bar-group" style="flex:1">
      <div class="wf-stacked" style="height:${Math.min(totalH,chartH)}px;">
        ${segs.map(s=>`<div class="wf-seg ${s.cls}" style="height:${s.h}px;flex-shrink:0;"></div>`).join('')}
      </div>
      <div class="wf-label">${ch.icon}<br>${ch.name.split('/')[0]}<br><span style="color:${ch.gm>=0.3?'var(--forest)':ch.gm>=0.15?'var(--status-caution)':'var(--rust)'};font-weight:500">${ch.yourReceipt>0?fmtP(ch.gm||0):''}</span></div>
    </div>`;
  }).join('');
}

// INIT
calculate();

// ── CPG Bridge: parent-page save/hydrate helpers ─────────────────────────────
// Same postMessage contract as sales-estimator.html so the parent React
// wrapper (Tools.jsx::ToolEmbed) can share Save-to-Projects logic across
// every financial tool. All communication is `{__cpg: '<verb>', ...}`.
//
// State surface: every <input> with an id, plus the currently-active tab.
st.__cpgDirty = false;
st.__cpgViewOnly = false;

bridge.cpgCollectState = function () {
  var out = {};
  root.querySelectorAll('input[id]').forEach(function (el) {
    if (el.type === 'checkbox' || el.type === 'radio') {
      out[el.id] = !!el.checked;
    } else {
      out[el.id] = el.value;
    }
  });
  var active = root.querySelector('.tab-panel.active');
  out.__activeTab = active ? active.id.replace(/^tab-/, '') : 'welcome';
  return out;
};

bridge.cpgApplyState = function (snap) {
  if (!snap || typeof snap !== 'object') return;
  Object.keys(snap).forEach(function (id) {
    if (id.indexOf('__') === 0) return; // skip meta keys
    var el = $(id);
    if (!el || el.tagName !== 'INPUT') return;
    if (el.type === 'checkbox' || el.type === 'radio') {
      el.checked = !!snap[id];
    } else {
      el.value = snap[id];
    }
  });
  try { calculate(); } catch (e) { /* recalc after hydrate — safe */ }
  // Hydrating a saved snapshot counts as "dirty" so Save Draft is
  // enabled immediately on re-open (matches sales-estimator behaviour).
  st.__cpgDirty = true;
  bridge.cpgRefreshSaveDraftEnabled && bridge.cpgRefreshSaveDraftEnabled();
  if (snap.__activeTab) {
    try { showTab(snap.__activeTab); } catch (e) { /* fall through */ }
  }
};

bridge.cpgSetViewOnly = function (readOnly) {
  root.querySelectorAll('input, select, textarea').forEach(function (el) {
    if (readOnly) {
      el.setAttribute('data-cpg-locked', '1');
      el.disabled = true;
    } else if (el.getAttribute('data-cpg-locked') === '1') {
      el.removeAttribute('data-cpg-locked');
      el.disabled = false;
    }
  });
  root.classList.toggle('cpg-view-only', !!readOnly);
  st.__cpgViewOnly = !!readOnly;
  bridge.cpgRefreshSaveDraftEnabled && bridge.cpgRefreshSaveDraftEnabled();
};

// Dirty-state + Save Draft / Save Result button toggling. Same rules as
// sales-estimator.html so both tools feel identical.
bridge.cpgRefreshSaveDraftEnabled = function () {
  root.querySelectorAll('.cpg-save-draft-btn').forEach(function (b) {
    var isResult = b.getAttribute('data-cpg-save-mode') === 'result';
    var enabled = isResult
      ? !st.__cpgViewOnly
      : (st.__cpgDirty && !st.__cpgViewOnly);
    b.disabled = !enabled;
    b.style.display = st.__cpgViewOnly ? 'none' : '';
    b.title = isResult
      ? 'Save this margin analysis + final result to a Project folder — opens view-only when re-opened.'
      : (enabled
          ? 'Save your progress to a Project folder — you can continue from where you left off.'
          : 'Start filling in this step to enable Save Draft.');
  });
};

(function injectSaveDraftButtons () {
  // Welcome tab is intro-only — no save. Every other tab gets a save button
  // appended to its .page-nav row (right of the Next-Step button):
  //   • Step tabs (cogs, pricing, channels, trade): Save Draft → 'save-draft'
  //   • Results tab:                                  Save Result → 'save-result'
  root.querySelectorAll('.tab-panel').forEach(function (panel) {
    var slug = (panel.id || '').replace(/^tab-/, '');
    if (slug === 'welcome') return;
    var nav = panel.querySelector('.page-nav');
    if (!nav) return;
    var isResult = (slug === 'results');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nav-btn save cpg-save-draft-btn';
    btn.setAttribute('data-testid', isResult ? 'iframe-save-result' : 'iframe-save-draft');
    btn.textContent = isResult ? 'Save Result' : 'Save Draft';
    btn.setAttribute('data-cpg-save-mode', isResult ? 'result' : 'draft');
    // Save Result: enabled by default (Results always has a valid model).
    // Save Draft: starts disabled — flipped on by first input event.
    btn.disabled = !isResult;
    btn.title = isResult
      ? 'Save this margin analysis + final result to a Project folder — opens view-only when re-opened.'
      : 'Start filling in this step to enable Save Draft.';
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      try {
        hooks.post(
          { __cpg: isResult ? 'save-result' : 'save-draft' },
          '*'
        );
      } catch (e) { /* cross-origin — ignore */ }
    });
    nav.appendChild(btn);
  });
  root.addEventListener('input', function (ev) {
    if (!ev.target || ev.target.tagName !== 'INPUT') return;
    if (st.__cpgDirty) return;
    st.__cpgDirty = true;
    bridge.cpgRefreshSaveDraftEnabled();
  });
})();

// Mirror active-tab changes back to the parent React wrapper so the
// "VIEW-ONLY SNAPSHOT" toolbar can react instantly (matches
// sales-estimator.html pattern).
(function () {
  var _showTab = showTab;
  showTab = function (id) {
    _showTab(id);
    try { hooks.post({ __cpg: 'tab', tab: id }, '*'); } catch (e) { /* cross-origin — ignore */ }
  };
})();

  const GLOBALS = { showTab: (...a) => showTab(...a), tip, calculate, distribState };
  Object.assign(window, GLOBALS);
  bridge.destroy = () => {
    docListeners.forEach(([t, f]) => document.removeEventListener(t, f));
    Object.keys(GLOBALS).forEach((k) => { if (window[k] === GLOBALS[k]) delete window[k]; });
  };
  return bridge;
}
